import React from 'react';
import { withTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { ReactComponent as FullscreenIcon } from '@public/images/fullscreen/zoomIn.svg';
import { ReactComponent as FullscreenExitIcon } from '@public/images/fullscreen/zoomOut.svg';
import { IFullScreenButtonViewProps } from './interfaces';
import { useStyles } from './styles';

const FullScreenButtonView = ({
  onClick,
  isFullscreen,
  t: translate,
}: IFullScreenButtonViewProps) => {
  const tooltipText = isFullscreen
    ? translate('tooltips.fullscreenExit')
    : translate('tooltips.fullscreen');

  const classes = useStyles();
  const rootSx = { ...classes.root };

  return (
    <Tooltip title={tooltipText}>
      <IconButton onClick={onClick} sx={rootSx} disableRipple>
        {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default withTranslation()(FullScreenButtonView);
